import type { TipsContent } from "@/app/components/Tips";

const additionalInformation: TipsContent = {
	summary:
		"Additional information on a CV can provide a more complete picture of your skills, experience, and personal interests.",
	tips: [
		"Only include information that is relevant to the job you are applying for. Avoid adding unnecessary information that might distract from your qualifications for the job.",
		"Keep the additional information brief and to the point. Use bullet points to make it easy to read and scan.",
		{
			text: "Use the additional information section to highlight any additional accomplishments or skills that didn't fit elsewhere in your CV.",
			items: [
				"Any awards or recognition you've received",
				"Any volunteer work you've done",
				"Any relevant hobbies or interests",
			],
		},
		"If you are fluent in another language, include this information in the additional information section. This can be particularly useful if the job you are applying for requires language skills.",
		"If the company or organization has a specific culture or values that align with your personal interests or hobbies, you can include this information to demonstrate your fit with the company.",
	],
};

export default additionalInformation;
